import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import moment from 'moment-timezone';
import Spinner from '../../../../../../components/Spinner';
import Segment from '../../../../../../components/Segment';
import Form from '../../../../../../components/Form/Form';
import InviteFriendModal from '../../../../components/InviteFriendModal';

import './ViewOfficeHours.scss';

import HeroImage1 from './images/OH-Header-3.jpg';
import FooterImage1 from './images/Depositphotos_53801085.jpg';
import CancelImage from './images/cancel.png';

import FacebookLogoImage from './images/logo-facebook.png';
import EmailImage from './images/mail-logo.png';

import WeChatLogo from './images/wechat-logo.png';
import QRImage from './images/qr-code.png';

// Company Images
import McKinseyCompanyLogo from './images/companies/McKinsey_and_Company_Logo.png';
import MicrosoftLogo from './images/companies/microsoft.png';
import GoldmanSachsLogo from './images/companies/goldman-sachs-logo.png';
import AppleLogo from './images/companies/apple.png';
import DeloitteLogo from './images/companies/Deloitte-logo.png';
import BainLogo from './images/companies/bain.png';
import GoogleLogo from './images/companies/google.png';
import PWCLogo from './images/companies/pwc.png';
import MorganStanleyLogo from './images/companies/morgan-stanley.png';
import FacebookLogo from './images/companies/facebook.png';
import CitiLogo from './images/companies/citi-logo.png';
import NetflixLogo from './images/companies/Netflix_logo.png';
import NYULangoneLogo from './images/companies/NYULangone_Logo.png';
import YahooLogo from './images/companies/yahoo-logo.png';
import BAHLogo from './images/companies/bah-only-logo.png';

// Why RSVP
import NoPressure_Image from './images/noun_1097288.png';
import LineSkip_Image from './images/Angry-customers.png';
import Exclusive_Image from './images/velvet-rope.png';
import NoBarriers_Image from './images/barrier.png';
import Ignite_Image from './images/ignite.png';
import StreetBrawls_Image from './images/competition.png';

import { facebookShare, addToGoogleCalendar, validateEmail, getParameterByName } from 'components/Utils';

const segment = new Segment();

const monthNames = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
// eslint-disable-next-line
const EmailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

class ViewOfficeHours extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      inviteFriendModalIsOpen: false,
      SessionModal: null,
      registerFormError: null,
      submittingRegisterForm: false,
      registeredSessions: [],
      submittingInviteForm: false,
      inviteForm: {
        send_to: null,
        email: null,
        name: null
      },
      inviteFormErrors: {
        send_to: null,
        email: null,
        name: null
      }
    };

    this.ScrollToAction = this.ScrollToAction.bind(this);
    this.facebookShareThisPage = this.facebookShareThisPage.bind(this);
    this.setSessionModal = this.setSessionModal.bind(this);
    this.setInviteModal = this.setInviteModal.bind(this);
    this.handleEmailInput = this.handleEmailInput.bind(this);
    this.attemptSessionRegister = this.attemptSessionRegister.bind(this);
    this.addToGoogleCalendar = this.addToGoogleCalendar.bind(this);
    this.handleInviteForm = this.handleInviteForm.bind(this);
    this.sendEmailShare = this.sendEmailShare.bind(this);
    this.getSessions = this.getSessions.bind(this);
  }

  componentDidMount () {
    segment.page();
  }

  validateEmail (email) {
    return new Promise(resolve => {
      if (email === '') {
        resolve(false);
      }

      if (typeof email === 'string') {
        if (EmailRegex.test(email) === false) {
          resolve(false);
          return;
        }

        axios.post(__LaravelDomain + '/api/v04/validator', {
          email: email,
          rules: {
            email: 'email|mailgun_validate|cleantalk_validate'
          }
        }, {
          headers: {
            'Authorization': 'Basic cGFyYWdvbjpvbmU=',
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(data => {
          resolve(true);
        }).catch(err => {
          resolve(false);
        });
      } else {
        resolve(false);
      }
    });
  }

  attemptSessionRegister () {
    this.setState({
      submittingRegisterForm: true,
    });

    this.validateEmail(this.state.email).then(wasValid => {
      if (wasValid === false) {
        this.setState({
          registerFormError: 'Please enter a valid Email',
          submittingRegisterForm: false,
        });
        return;
      }

      const SessionEntry = this.getSessions()[this.state.SessionModal];

      console.log('Registering for session ' + JSON.stringify({
        UserEmail: this.state.email,
        SessionId: SessionEntry.id,
        TrackUrl: window.location.href,
        UtmSource: getParameterByName('utm_source'),
        UtmMedium: getParameterByName('utm_medium'),
        UtmCampaign: getParameterByName('utm_campaign'),
        UtmTerm: getParameterByName('utm_term'),
        UtmContent: getParameterByName('utm_content'),
        AnonId: segment.anonId,
      }, null, 2));

      this.props.RegisterSession({
        variables: {
          UserEmail: this.state.email,
          SessionId: SessionEntry.id,
          TrackUrl: window.location.href,
          UtmSource: getParameterByName('utm_source'),
          UtmMedium: getParameterByName('utm_medium'),
          UtmCampaign: getParameterByName('utm_campaign'),
          UtmTerm: getParameterByName('utm_term'),
          UtmContent: getParameterByName('utm_content'),
          AnonId: segment.anonId,
        }
      }).then(() => {
        segment.track('Reserved a spot on office hours', {
          user_email: this.state.email,
          session_id: SessionEntry.id,
          session_title: SessionEntry.advisor_bio,
          advisor_id: SessionEntry.host.id,
          advisor_name: `${SessionEntry.host.first_name} ${SessionEntry.host.last_name}`,
        });

        gtag('event', 'conversion', {
          'send_to': 'AW-952196026/mlweCImZ9XkQureFxgM',
        });

        console.log('Session Succesfully Registered');
        console.log('Registered for the following sessions: ', JSON.stringify({
          registeredSessions: [
            ...this.state.registeredSessions,
            SessionEntry.id,
          ]
        }, null, 2));

        this.setState({
          submittingRegisterForm: false,
          registeredSessions: [
            ...this.state.registeredSessions,
            SessionEntry.id,
          ]
        });
      });
    });
  }

  addToGoogleCalendar () {
    const SessionEntry = this.getSessions()[this.state.SessionModal];
    console.log('Added to Calander session: ' + JSON.stringify(this.getSessions()[this.state.SessionModal]));

    // eslint-disable-next-line
    let description = `Thank you for joining Secrets to Securing Your Dream Career. Please use this link to access the session: https://www.paragonone.com/signup/careerQandA/join/${SessionEntry.id}

This 1-hour long online Q&A with a top professional is limited to about 10 guests. Feel free to ask her or him about career path, industry insights, interview preparation and any career related questions.

To take full advantage, we recommend you:
1. Find a quiet space, free from distractions so you can listen and learn
2. Prepare any questions you may have and take the opportunity to ask them during your session
3. Get ready, secrets are coming your way!

For technical issues, please contact byron@paragonone.com. For all other questions, please contact sissi@paragonone.com
`;

    addToGoogleCalendar(
      `Paragon One | ${SessionEntry.host.first_name} ${SessionEntry.host.last_name} - ${SessionEntry.advisor_bio}`,
      SessionEntry.start_time,
      SessionEntry.end_time,
      description,
      `Join URL: https://www.paragonone.com/signup/careerQandA/join/${SessionEntry.id}`
    );
  }

  handleEmailInput (event) {
    this.setState({
      email: event.target.value.email,
      registerFormError: null,
    });
  }

  ScrollToAction (RefID) {
    return event => {
      const node = ReactDOM.findDOMNode(this.refs[RefID]);

      if (node) {
        node.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };
  };

  setSessionModal (val) {
    return () => {
      if (val !== null) {
        let SessionEntry = this.getSessions()[val];

        if (SessionEntry) {
          segment.track('Opened an Office Hours session modal', {
            session_id: SessionEntry.id,
            session_title: SessionEntry.advisor_bio,
            advisor_id: SessionEntry.host.id,
            advisor_name: `${SessionEntry.host.first_name} ${SessionEntry.host.last_name}`,
          });
        }
      }

      this.setState({
        SessionModal: val,
        email: ''
      });
    };
  }

  setInviteModal (val) {
    return () => this.setState({
      inviteFriendModalIsOpen: val,
    });
  }

  facebookShareThisPage (evt) {
    evt.preventDefault();

    segment.track('Initiated a facebook share', {
      page: window.location
    });

    return facebookShare();
  }

  handleInviteForm (event) {
    this.setState({
      inviteForm: event.target.value,
    });
  }

  sendEmailShare () {
    console.log(this.state.inviteForm);
    if (!this.state.inviteForm) {
      return false;
    }

    let hasErrors = false;
    let validationErrors = {
      send_to: null,
      email: null,
      name: null
    };

    if (!this.state.inviteForm.send_to || !validateEmail(this.state.inviteForm.send_to)) {
      validationErrors.send_to = 'Please enter a valid email';
      hasErrors = true;
    }

    if (!this.state.inviteForm.email || !validateEmail(this.state.inviteForm.email)) {
      validationErrors.email = 'Please enter a valid email';
      hasErrors = true;
    }

    if (!this.state.inviteForm.name || !validateEmail(this.state.inviteForm.name)) {
      validationErrors.name = 'Please enter your name';
      hasErrors = true;
    }

    this.setState({
      inviteFormErrors: validationErrors,
    });

    if (hasErrors) return false;

    if (Object.prototype.hasOwnProperty.call(this.state.inviteForm, 'send_to') &&
     Object.prototype.hasOwnProperty.call(this.state.inviteForm, 'name')) {
      this.setState({
        submittingInviteForm: true,
      });
      const Recipients = this.state.inviteForm.send_to.split(',') || [];

      if (Recipients.length === 0) {
        return false;
      }

      const Emails = Recipients.reduce((sum, val) => {
        if (EmailRegex.test(val.replace(/\s+/g, ''))) {
          return [
            ...sum,
            val.replace(/\s+/g, '')
          ];
        }
        return sum;
      }, []);

      this.props.SendEmailInvite({
        variables: {
          SendArray: Emails,
          Email: this.state.inviteForm.email || '',
          Name: this.state.inviteForm.name,
          Message: this.state.inviteForm.optional_message
        }
      }).then(() => {
        this.setState({
          submittingInviteForm: false,
        });
        this.setInviteModal(false)();
      }).catch(err => {
        console.log(err);
        this.setState({
          submittingInviteForm: false,
        });
      });
    }
  }

  getSessions () {
    let sessions = this.props.SessionData.getOfficeSessions2.map(v => v);

    return sessions.sort((a, b) => {
      return a.start_time === b.start_time ? 0 : (a.start_time > b.start_time ? 1 : -1);
    });
  }

  renderSelectionModal () {
    if (this.state.SessionModal !== null) {
      const SessionEntry = this.getSessions()[this.state.SessionModal];
      // const StartDate = new Date(SessionEntry.start_time.slice(0, -5) + '-00:00');
      // let TimeZone = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];

      // if (TimeZone.slice(-2) === '00') {
      //   TimeZone = TimeZone.slice(0, -2);
      // }

      const StartDate = moment(SessionEntry.start_time).tz('America/New_York');
      const TimeZone = 'EST';

      return (
        <div className='OfficeHoursModal'>
          <div className='OfficeHoursModal__Background' onClick={this.setSessionModal(null)} />
          <div className='OfficeHoursModal__Content'>
            <div className='OfficeHoursModal__InternalWrap'>
              <a className='OfficeHoursModal__Cancel' onClick={this.setSessionModal(null)}>
                <img src={CancelImage} />
              </a>
              <div className='OfficeHour__EntryWrap'>
                <h5 className='OfficeHour__TimeHeader'>
                  {StartDate.format('MMM. DD | hh:mm a')} {TimeZone}
                </h5>
                <h3>{SessionEntry.advisor_bio}</h3>
                <img src={IMAGECACHELINK + '/' + IMAGESTAGE + '/300x300/' + SessionEntry.host.photo} />
                <h5 className='OfficeHour__HostName'>{SessionEntry.host.first_name + ' ' + SessionEntry.host.last_name}</h5>
                <p className='OfficeHour__AdvisorBio'>{SessionEntry.title}</p>
                <p>{SessionEntry.company_1}</p>
                <p>{SessionEntry.company_2}</p>
                <br />
                {(this.state.registeredSessions.includes(SessionEntry.id))
                ? <div>
                  <h3>Reservation Confirmed</h3>
                  <a className='button' style={{ maxWidth: '240px' }} onClick={this.addToGoogleCalendar}>Add to Google Calendar</a>
                </div>
                : <div>
                  <h3>Reserve your spot now for FREE!</h3>
                  {(this.state.registerFormError !== null) ? <p style={{ color: 'red' }}>{this.state.registerFormError}</p> : null}
                  <div className='row'>
                    <div className='col-md-9'>
                      <Form onChange={this.handleEmailInput}>
                        <input className='OfficeHoursModal__EmailInput' name='email' placeholder='Enter your email' />
                      </Form>
                    </div>
                    <div className='col-md-3'>
                      <a className='button' onClick={this.attemptSessionRegister}>
                        {(this.state.submittingRegisterForm === false) ? 'Reserve' : <Spinner className='spinner--white' style={{ fontSize: '4px', margin: '10px auto' }} />}
                      </a>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  renderSessions () {
    if (this.props.SessionData.loading === false) {
      return this.getSessions().map((val, index) => {
        // const StartDate = new Date(val.start_time.slice(0, -5) + '-00:00');
        // let TimeZone = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];

        // if (TimeZone.slice(-2) === '00') {
        //   TimeZone = TimeZone.slice(0, -2);
        // }

        // This is the old time header: {monthNames[StartDate.getMonth()]}. {StartDate.getDate()} | {('0' + StartDate.getHours()).slice(-2)}:{('0' + StartDate.getMinutes()).slice(-2)} {TimeZone}

        const StartDate = moment(val.start_time).tz('America/New_York');
        const TimeZone = 'EST';

        return (
          <div key={index} className='col-lg-3 col-md-6'>
            <div className='OfficeHour__EntryWrap'>
              <h5 className='OfficeHour__TimeHeader'>
                {StartDate.format('MMM. DD | hh:mm a')} {TimeZone}
              </h5>
              <h3>{val.advisor_bio}</h3>
              <img src={IMAGECACHELINK + '/' + IMAGESTAGE + '/300x300/' + val.host.photo} />
              <h5 className='OfficeHour__HostName'>{val.host.first_name + ' ' + val.host.last_name}</h5>
              <p className='OfficeHour__AdvisorBio'>{val.title}</p>
              <p>{val.company_1}</p>
              <p>{val.company_2}</p>
              {
                (moment(val.start_time).diff(moment(), 'minutes') < -60)
                  ? (
                    <p style={{ 'margin-top': '20px', 'font-style': 'italic', 'font-weight': 'bold' }}>This Meeting is Over</p>
                  )
                  : (
                    <a className='button' onClick={this.setSessionModal(index)}>
                      RSVP Now
                    </a>
                  )
              }
            </div>
          </div>
        );
      });
    }
    return <Spinner />;
  }

  render () {
    return (
      <div style={{ background: '#f0f1f3', position: 'relative' }}>
        {(this.state.SessionModal !== null) ? this.renderSelectionModal() : null}
        <InviteFriendModal isOpen={this.state.inviteFriendModalIsOpen} onDismiss={this.setInviteModal(false)} sendEmailInvite={this.props.SendEmailInvite} />
        <div className='HeroSection'>
          <div className='HeroSection__BackGroundWrap'>
            <img src={HeroImage1} />
          </div>
          <div className='HeroSection__ContentWrap'>
            <div className='container'>
              <div className='row'>
                <div className='col-lg-8 col-md-10'>
                  <h1 className='heading-1'>Get free career advice from top professionals</h1>
                  <p className='subhead-1'>
                    Secrets to Securing Your Dream Career is a series of small online group chats with some of America’s most accomplished professionals from a range of industries. And you’re invited!
                  </p>
                  <br />
                  <p style={{ color: '#47c2f0', margin: 0 }}>Please note: This is a free, invite-only event with limited availability.</p>
                  <br />
                  <a onClick={this.ScrollToAction('OfficeHourAnchor')} className='button'>RSVP Now!</a>
                </div>
              </div>
              <div className='HeroSection__CompanyLogos hidden-xs-down'>
                <p className='HeroSection__SubText'>Our professionals have experience at companies including:</p>
                <div className='HeroSection__CompanyImageWrap'>
                  <img src={McKinseyCompanyLogo} height='50' />
                  <img src={MicrosoftLogo} height='50' />
                  <img src={GoldmanSachsLogo} height='80' />
                  <img src={AppleLogo} height='60' />
                  <img src={DeloitteLogo} height='50' />
                  <img src={BainLogo} height='70' />
                  <img src={GoogleLogo} height='55' />
                  <img src={PWCLogo} height='65' />
                  <img src={FacebookLogo} height='50' />
                  <img src={CitiLogo} height='50' />
                  <img src={NetflixLogo} height='50' />
                  <img src={NYULangoneLogo} height='90' />
                  <img src={YahooLogo} height='60' />
                  <img src={MorganStanleyLogo} height='50' />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='WhyRSVP__Wrapper'>
          <div className='container'>
            <h3>Why RSVP?</h3>
            <div className='row'>
              <div className='col'>
                <p>
                  How can I get into VC? How do I become a Product Manager?<br />
                  What does it take to switch to investment banking or consulting? How do I get a job at Google?<br />
                  Get the answers you need to explore and reach your career goals.<br />
                </p>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-4 col-md-6'>
                <img src={NoPressure_Image} />
                <h6>Solve your career questions</h6>
                <p>Ask exactly what you want and learn from the questions of others. Sessions last 1 hour and are limited to about 10 guests.</p>
              </div>
              <div className='col-lg-4 col-md-6'>
                <img src={Ignite_Image} />
                <h6>Learn from success</h6>
                <p>Our speakers have worked at the most prestigious companies, including as hiring managers. Each session is full of info you can’t get anywhere else.</p>
              </div>
              <div className='col-lg-4 col-md-6'>
                <img src={NoBarriers_Image} />
                <h6>Explore different industries</h6>
                <p>Pick the sessions that interest you - in any industry or function. Then learn if they’re for you, how to switch, and what next steps to take.</p>
              </div>
            </div>
          </div>
        </div>
        <div className='HowDoesItWork__Wrapper'>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <h3>How does it work?</h3>
                <p>1. RSVP to as many free sessions as you like</p>
                <p>2. Log on from anywhere via our video chat</p>
                <p>3. Get the career information you need!</p>
              </div>
            </div>
          </div>
        </div>
        <div className='OfficeHours__Wrapper' ref='OfficeHourAnchor'>
          <div className='container'>
            <h1 className='SegmentTitle'>Secrets to Securing Your Dream Career</h1>
            <p className='SegmentSubTitle'>Curious about another role or industry? Or want to succeed faster in your current job? You won’t get the chance to learn from our speakers anywhere else. RSVPs are open for a limited time to invited professionals like you, so register today.</p>
            <div className='row'>
              {this.renderSessions()}
            </div>
          </div>
        </div>
        <div className='FooterImage'>
          <div className='FooterImage__BackGroundWrap'>
            <img src={FooterImage1} />
          </div>
          <div className='FooterImage__ContentWrap'>
            <div className='container'>
              <div className='FooterImage__InternalWrap'>
                <p className='FooterImage__MinorTitle'>Paragon One provides personalized career and entrepreneurship coaching for college students and working professionals. Our programs combine mentoring and exclusive online courses. Originally started as an invite-only mentor network at MIT 10 years ago, Paragon One has now enabled its clients to secure internships and jobs with the most highly respected US companies.</p>
                <a href='https://www.paragonone.com/' className='button button--trim'>Learn more about Paragon One</a>
                <p className='SegmentSubTitle'>Be someone's career hero!<br />Share Secrets to Securing Your Dream Career with a friend:</p>
                <div className='row SocialIntergrations'>
                  <a href='#' onClick={this.facebookShareThisPage}>
                    <img style={{ padding: '1px 14px 0px 11px' }} src={FacebookLogoImage} />
                  </a>
                  <a style={{ cursor: 'pointer' }} onClick={this.setInviteModal(true)}>
                    <img src={EmailImage} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className='OfficeHours'>
          <div className='container'>
            <div className='row'>
              <div className='col-sm'>
                <h5>Contact Us</h5>
                <p>info@paragonone.com<br />1-888-527-6888</p>
              </div>
              <div className='col-sm'>
                <img style={{ height: '75px' }} src={QRImage} />
                <img style={{ height: '45px', marginTop: '15px' }} src={WeChatLogo} />
              </div>
            </div>
            <div className='row'>
              <p className='copy'>&copy; 2017 Paragon One, All Rights Reserved</p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default ViewOfficeHours;



// WEBPACK FOOTER //
// ./src/routes/officehours-v2/routes/ViewOfficeHours/components/ViewOfficeHours/index.js